/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */

const defaultDrawing = {
  _debugDraw(context, element, item, api) {
    /* !! Не применять context.save / restore нигде, кроме отладки !! */
    context.save()

    context.strokeStyle = '#00FF00'
    context.linewidth = 3
    context.setLineDash([2, 2])
    const { box } = api.geometry.boundingPolygon(
      api.geometry.scaleCoords(
        {
          x: 0,
          y: 0,
          h: 100,
          w: 100
        },
        element.extendRedraw,
      ),
      item.coords,
      item.rotation,
    )
    context.strokeRect(
      box.xmin,
      box.ymin,
      box.xmax - box.xmin,
      box.ymax - box.ymin,
    )
    context.restore()
    context.save()
    api.drawHelpers.transformContext(context, item.coords, item.rotation)
    context.setLineDash([5, 5])
    context.linewidth = 5
    context.strokeRect(0, 0, 100, 100)

    context.setLineDash([])
    context.linewidth = 2
    element.layers.forEach((layer) => {
      if (layer.rotation) {
        context.save()
        api.drawHelpers.rotateLayer(context, layer.rotation)
      }
      context.strokeRect(
        layer.coords.x,
        layer.coords.y,
        layer.coords.w,
        layer.coords.h,
      )
      if (layer.rotation) {
        context.restore()
      }
    })
    context.strokeStyle = '#FF0000'
    if (element.activeZones) {
      element.activeZones.forEach((zone) => {
        const { coords } = zone
        context.beginPath()
        context.strokeRect(coords.x, coords.y, coords.w, coords.h)
        context.moveTo(coords.x, coords.y)
        context.lineTo(coords.x + coords.w, coords.y + coords.h)
        context.moveTo(coords.x, coords.y + coords.h)
        context.lineTo(coords.x + coords.w, coords.y)
        context.stroke()
        context.moveTo(0, 0)
      })
    }
    context.restore()
  },
  /**
   * Кнопка
   *
   * | preActiveLayers | activeLayer | postActiveLayers
   *
   * Предполагается, что функция действия будет переключать displayFunctionValues.state.
   *
   * В качестве слоя состояния будет нарисован layers[activeLayers[state]]
   *
   * displayFunctionValues.preActiveLayers - индексы слоев, рисующихся до слоя состояния
   * displayFunctionValues.activeLayers - индексы слоев состояний
   * displayFunctionValues.state - текущее состояние
   * displayFunctionValues.postActiveLayers - слои, после слоя состояния
   */
  drawButton(context, element, item, api) {
    const values = item.displayFunctionValues
    api.drawHelpers.transformContext(context, item.coords, item.rotation)
    if (values.preActiveLayers) {
      values.preActiveLayers.forEach((layerIndex) => {
        const layer = element.layers[layerIndex]
        api.drawHelpers.drawLayer(context, layer, api)
      })
    }
    const stateLayer = element.layers[values.activeLayers[values.state]]
    api.drawHelpers.drawLayer(context, stateLayer, api)

    if (values.postActiveLayers) {
      values.postActiveLayers.forEach((layerIndex) => {
        const layer = element.layers[layerIndex]
        api.drawHelpers.drawLayer(context, layer, api)
      })
    }
    api.drawHelpers.resetTransform(context)
  },
  /**
   * Рисование вентиля
   *
   * Слои:  | Bottom | Action (вертится) | Top
   * За роли слоев отвечают атрибуты displayFunctionValues -
   * bottomIndex, actionIndex, topIndex
   *
   * displayFunctionValues.rotation
   */
  drawValve(context, element, item, api) {
    const values = item.displayFunctionValues
    api.drawHelpers.transformContext(context, item.coords, item.rotation)
    if (values.bottomIndex) {
      api.drawHelpers.drawLayer(
        context,
        element.layers[values.bottomIndex],
        api,
      )
    }

    api.drawHelpers.rotateLayer(context, { angle: values.rotation })
    api.drawHelpers.drawLayer(context, element.layers[values.actionIndex], api)
    api.drawHelpers.rotateLayer(context, { angle: values.rotation }, true)

    if (values.topIndex) {
      api.drawHelpers.drawLayer(context, element.layers[values.topIndex], api)
    }
    api.drawHelpers.resetTransform(context)
  },

  /**
   * Нарисовать все слои элемента по порядку
   */
  drawAllLayers(context, element, item, api) {
    api.drawHelpers.transformContext(context, item.coords, item.rotation)
    element.layers.forEach((layer) => {
      api.drawHelpers.drawLayer(context, layer, api)
    })
    api.drawHelpers.resetTransform(context)
  },

  _drawGuides(context, element, item, api) {
    context.strokeStyle = '#0078c1'
    context.linewidth = 3

    const guides = api.geometry.getGuides(item)
    const p = (coords) => [coords.x + coords.w / 2, coords.y + coords.h / 2]
    context.beginPath()
    context.moveTo(...p(guides[0]))
    context.lineTo(...p(guides[1]))
    context.lineTo(...p(guides[3]))
    context.lineTo(...p(guides[2]))
    context.lineTo(...p(guides[0]))
    context.stroke()

    context.fillStyle = '#0078c1'

    guides.forEach((guide) => {
      context.fillRect(guide.x, guide.y, guide.w, guide.h)
    })

    context.strokeStyle = '#000000'
    context.linewidth = 1

    api.drawHelpers.resetTransform(context)
  },
  drawNonActiveElement(context, element, item, api) {
    api.drawHelpers.transformContext(context, item.coords, item.rotation)
    const values = item.displayFunctionValues
    let layer = 0
    if (values.state) {
      layer = values.state
    }
    api.drawHelpers.drawLayer(context, element.layers[layer], api)
    api.drawHelpers.resetTransform(context)
  },
  drawBuffer(context, element, item, api) {
    const values = item.displayFunctionValues
    if (item.gif) {
      if (!item.gif.running && values.running) {
        item.gif.start()
      } else if (item.gif.running && !values.running) {
        item.gif.stop()
      }
    }

    const { buffer } = item.displayFunctionValues
    if (!buffer || !values.draw) {
      return
    }
    const layer = element.layers[0]
    const {
      x, y, w, h
    } = layer.coords

    api.drawHelpers.transformContext(context, item.coords, item.rotation)
    if (layer.rotation) {
      this.rotateLayer(context, layer.rotation)
    }
    context.drawImage(buffer, x, y, w, h)
    if (layer.rotation) {
      this.rotateLayer(context, layer.rotation, true)
    }
    api.drawHelpers.resetTransform(context)
  },
  nothing() {}
}

export default defaultDrawing
